module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vnerv11-022837352654b85c98e0388f7f94b79f.jpg";